function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref4e8"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref4e8"] = parcelRequire;
}

/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Final build : npm run build
---
**/ /**
 * API v3 contains changes to save high scores at the host level.
 * API v4 contains changes for retrieving the referral score from the handshake.
 * API v5 contains changes to retrieve the game save from the handshake.
 * [DEPRECATED] API v6 contains changes for embedded games.
 * API v7 contains changes to support files sharing.
 * API v8 contains changes to support saving the game state at any times.
 * API v9 adds Development mode and changes to games embedding (deprecates v6).
 * API V10 adds a message to trigger feedback dialog.
 * API V11 adds support for SMLG app.
 * API V12 add local dev mode detection (skips handshake).
 */ const $bd226c24ee4b7195$var$API_VERSION = 12;
// Private consts.
/** @const {number} */ const $bd226c24ee4b7195$var$HANDSHAKE_INTERVAL_MS = 500;
/** @const {number} */ const $bd226c24ee4b7195$var$SMLG_HANDSHAKE_INTERVAL_MS = 50;
/** @const {string} */ const $bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE = "hpi";
/** @const {string} */ const $bd226c24ee4b7195$var$HOST_TO_CHILD_HANDSHAKE = "hpo";
/** @const {number} */ const $bd226c24ee4b7195$var$MAX_STORAGE_BYTES = 32000;
/**
 * Whether we're in development mode. Somewhat obfuscated.
 */ const $bd226c24ee4b7195$var$DEV_MODE = !!window[[
    "_y",
    1
].join(Math.floor(Math.random())) + 0];
/**
 * Whether we're in local + top frame development mode (skips handhsake).
 */ const $bd226c24ee4b7195$var$LOCAL_DEV_MODE = $bd226c24ee4b7195$var$DEV_MODE && document.location.hostname == "localhost" && window.self == window.top;
/**
 * SMLG object if available.
 */ const $bd226c24ee4b7195$var$SMLG = window["__gci_axl"];
/**
 * Checks that the host is a *.google(rs).com or the embed.culturalspot.org
 * domain for embedded games. Private.
 * @param {string} origin
 * @return {boolean}
 */ const $bd226c24ee4b7195$var$isTrustedOrigin = (origin)=>{
    return $bd226c24ee4b7195$var$DEV_MODE || !!$bd226c24ee4b7195$var$SMLG || !!origin.match(/^https?\:\/\/((([\w-]*\.)+google(rs)?\.com)|(embed\.culturalspot\.org))(?:[\/:?#]|$)/i);
};
(function() {
    // Callback placeholder that will wait until document.body is available.
    let afterBodyParsed = ()=>{};
    if ($bd226c24ee4b7195$var$DEV_MODE) {
        const label = "Development mode";
        afterBodyParsed = ()=>{
            const watermarkEl = document.createElement("div");
            watermarkEl.innerText = label;
            const rules = {
                background: "rgba(255,0,0,.75)",
                color: "#fff",
                fontFamily: "Arial",
                fontSize: "12px",
                left: 0,
                padding: "12px",
                position: "fixed",
                top: 0,
                zIndex: 9999
            };
            Object.assign(watermarkEl.style, rules);
            document.body.appendChild(watermarkEl);
        };
        // Prefix console.logs with [Development mode].
        const ogLog = window["console"]["log"] || (()=>{});
        const prefixStyle = "color:teal";
        ogLog(`%cAxL v${$bd226c24ee4b7195$var$API_VERSION} ${label}`, prefixStyle);
        window["console"]["log"] = (...args)=>{
            args.unshift(prefixStyle);
            args.unshift(`%c[${label}]`);
            ogLog(...args);
        };
    } else {
        // Agressively kill all console.log outputs.
        window["console"]["log"] = ()=>{};
        afterBodyParsed = ()=>{
            // Hack to detect non-iframe mode and block content.
            if (window.self === window.top && !navigator.userAgent.includes("SMLG")) {
                document.body.textContent = "This experiment is not available on this platform.";
                window.close();
                // Throw to interrupt the app ASAP.
                throw "Experiment unavailable on this platform.";
            }
            // Hack to detect iframing from an unauthorized domain and block content.
            if (document.referrer && document.referrer !== "" && !$bd226c24ee4b7195$var$isTrustedOrigin(document.referrer)) {
                document.body.textContent = "This experiment is not available for embedding.";
                window.close();
                throw "Experiment unavailable for embedding.";
            }
        };
    }
    let observer;
    const check = ()=>{
        if (document.body) {
            afterBodyParsed();
            observer && observer.disconnect();
        }
    };
    observer = new MutationObserver(check);
    observer.observe(document.documentElement, {
        childList: true
    });
    check();
})();
/**
 * @param {*} val
 * @return {number}
 */ const $bd226c24ee4b7195$var$countBytes = (val)=>{
    return new Blob([
        JSON.stringify(val)
    ]).size;
};
/**
 * Test localStorage access. If not available, will issue a console warning and
 * the AxL.storage should still work as a volatile key/value store.
 */ let $bd226c24ee4b7195$var$ls = null;
try {
    $bd226c24ee4b7195$var$ls = window.localStorage;
} catch (e) {}
/**
 * A storage service implementation, currently relying on localStorage. Provides
 * a stable interface to the client, prevents collsions with other clients on
 * the same domain, and enforces quota restrictions. Also supports delegating
 * saving of High Scores to the Host.
 */ class $bd226c24ee4b7195$var$AxLStorage {
    /**
   * @param {string} storageKey
   * @param {function(!AxL.ChildToHost, !Object)} sendMessageCallback
   * @param {number|undefined} initHighScore initial high score supplied by
   *     Stella.
   * @param {number|undefined} referralScore referral score supplied by Stella.
   *     It represents the score of a third-party user that we'd like to beat.
   * @param {!Object|undefined} highScoreData object that represents the high
   *     score data, used to start the game where the user left off. The object
   * must be JSON serializable.
   */ constructor(storageKey, sendMessageCallback, initHighScore, referralScore, highScoreData){
        /** @private @const {string} */ this.storageKey_ = storageKey;
        /** @private {!Map<string, *>} */ this.storageMap_ = new Map();
        /** @private @const {function(!AxL.ChildToHost, !Object)} */ this.sendMessageCallback_ = sendMessageCallback;
        /** @private @const {number|undefined} */ this.referralScore_ = referralScore;
        /** @private {!Object} */ this.currentHighScoreObject_ = {
            "s": initHighScore,
            "d": highScoreData
        };
        // If the high score saving is delegated to Stella and no init high score
        // has been provided, try taking the high score from the local storage.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"] && !initHighScore) {
            const localHighScore = this.getHighScoreInLocalStorage_();
            const localHighScoreNumber = localHighScore["s"];
            if (localHighScoreNumber) this.currentHighScoreObject_["s"] = localHighScoreNumber;
            const localHighScoreData = localHighScore["d"];
            if (localHighScoreData) this.currentHighScoreObject_["d"] = localHighScoreData;
            // If there is actually a local high score number, try saving it along
            // with the data.
            if (localHighScoreNumber !== undefined) // Send a message up to Stella to save this local storage high score in
            // database.
            this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_HIGH_SCORE_FROM_LOCALSTORAGE, this.currentHighScoreObject_);
        }
        this.loadStorage_();
    }
    /**
   * @private
   */ loadStorage_() {
        this.storageMap_ = new Map();
        try {
            const dataObj = JSON.parse($bd226c24ee4b7195$var$ls && $bd226c24ee4b7195$var$ls.getItem(this.storageKey_) || "{}");
            this.storageMap_ = new Map(Object.entries(/** @type {!Object} */ dataObj));
        } catch (e) {}
    }
    /**
   * @private
   */ syncStorage_() {
        if (!$bd226c24ee4b7195$var$ls) return;
        $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#ts", Date.now() + "");
        $bd226c24ee4b7195$var$ls.setItem(this.storageKey_, JSON.stringify(Object.fromEntries(this.storageMap_)));
    }
    /**
   * @param {string} key
   * @return {!Promise<*>}
   * @export
   */ getItem(key) {
        return Promise.resolve(this.storageMap_.get(key));
    }
    /**
   * @param {string} key
   * @param {*} value
   * @return {!Promise<number>}
   * @export
   */ setItem(key, value) {
        return new Promise((resolve, reject)=>{
            try {
                if (this.bytesUsed - $bd226c24ee4b7195$var$countBytes(this.storageMap_.get(key)) + $bd226c24ee4b7195$var$countBytes(value) >= $bd226c24ee4b7195$var$MAX_STORAGE_BYTES) {
                    reject(new Error("Storage quota exceeded"));
                    return;
                }
                this.storageMap_.set(key, value);
                this.syncStorage_();
                resolve(this.usage);
            } catch (e) {
                reject(e);
            }
        });
    }
    /**
   * @param {string} key
   * @return {!Promise<number>}
   * @export
   */ removeItem(key) {
        return new Promise((resolve, reject)=>{
            this.storageMap_.delete(key);
            this.syncStorage_();
            resolve(this.usage);
        });
    }
    /**
   * Public exported method to save a new high score.
   * @param {number} score
   * @param {!Object=} optionalData extra state to save along with the high
   *     score to be able to continue where the user left off.
   * @param {!AxL.ScoreUnit=} scoreUnit Unit to represent the score (number of
   *     points, time, etc). Defaults to a number.
   * @param {boolean=} lowerScoreIsBetter whether or not a lower score is going
   *     to be considered better. Defaults to false.
   * @return {!Promise<number>}
   * @export
   */ setHighScore(score, optionalData, scoreUnit = $bd226c24ee4b7195$var$AxL.ScoreUnit.POINTS, lowerScoreIsBetter = false) {
        const scoreObj = {
            "s": score,
            "d": optionalData,
            "u": scoreUnit,
            "lb": lowerScoreIsBetter
        };
        // If we should delegate saving, we send an message up to the host.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"]) {
            // Save the new high score object.
            this.currentHighScoreObject_ = scoreObj;
            return new Promise((resolve, reject)=>{
                this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_HIGH_SCORE, scoreObj);
                // TODO(dcamilleri): add a handshake to set the high score in the local
                // storage in case storing with the host failed.
                resolve();
            });
        }
        return new Promise((resolve, reject)=>{
            if (!$bd226c24ee4b7195$var$ls) {
                reject(new Error("Storage not available"));
                return;
            }
            try {
                if (this.bytesUsed - $bd226c24ee4b7195$var$countBytes($bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#hs")) + $bd226c24ee4b7195$var$countBytes(scoreObj) >= $bd226c24ee4b7195$var$MAX_STORAGE_BYTES) {
                    reject(new Error("Storage quota exceeded"));
                    return;
                }
                const localHighScore = this.getHighScoreInLocalStorage_();
                // If the new score isn't better than the old one (based on the
                // scoreUnit provided, or the default one), let's reject that request.
                switch(scoreUnit){
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.POINTS:
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.PERCENTAGE:
                        if (score <= localHighScore["s"]) {
                            reject(new Error("Not highest score."));
                            return;
                        }
                        break;
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.TIME_MILLIS:
                        if (score >= localHighScore["s"]) {
                            reject(new Error("Not highest score."));
                            return;
                        }
                        break;
                    default:
                        break;
                }
                $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#ts", Date.now() + "");
                $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#hs", JSON.stringify(scoreObj));
                resolve(this.usage);
            } catch (e) {
                reject(e);
            }
        });
    }
    /**
   * Public exported method to save a game state at any point in the game.
   * @param {!Object} gameStateObject state object to save to be able to
   *     continue where the user left off. Can contain any info related to the
   * game, eg the current level, which artwork the user has unlocked, etc.
   * @return {!Promise<undefined>}
   * @export
   */ setGameState(gameStateObject) {
        if (!$bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.reject("Can't save Game State");
        // If we should delegate saving, we send an message up to the host.
        // Store the new game state into the global high score object.
        this.currentHighScoreObject_["d"] = gameStateObject;
        return new Promise((resolve, reject)=>{
            this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_GAME_STATE, gameStateObject);
            resolve();
        });
    }
    /**
   * If saving of high scores is delegated to Stella, returns the initial game
   * state data provided by the handshake or any new state that has been
   * saved since. This data is stored in the global high score object.
   * @return {!Promise<?Object>}
   * @export
   */ getGameState() {
        if (!$bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.reject("Can't get Game State");
        return Promise.resolve(this.currentHighScoreObject_["d"]);
    }
    /**
   * Retrieves the high score from the local storage.
   * @private
   * @return {!Object}
   */ getHighScoreInLocalStorage_() {
        return /** @type {!Object} */ JSON.parse($bd226c24ee4b7195$var$ls && $bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#hs") || "{}");
    }
    /**
   * Public method to retrieve the user's high score. High score is retrieved:
   * - From ContribService through Stella if the Stella high score integration
   * is launched.
   * - From a local storage otherwise.
   * @return {!Promise<?number>}
   * @export
   */ getHighScore() {
        // If saving of high scores is delegated to Stella, return the initial high
        // score provided or any new score that has been saved since.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.resolve(this.currentHighScoreObject_["s"]);
        // Otherwise take the score from the local storage.
        const scoreObj = this.getHighScoreInLocalStorage_();
        return Promise.resolve(scoreObj["s"]);
    }
    /**
   * Public method to retrieve the referral score. This data is supplied during
   * the handshake.
   * @return {!Promise<number|undefined>}
   * @export
   */ getReferralScore() {
        return Promise.resolve(this.referralScore_);
    }
    /**
   * @return {!Promise<undefined>}
   * @export
   */ flush() {
        if ($bd226c24ee4b7195$var$ls) {
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_);
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_ + "#ts");
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_ + "#hs");
        }
        this.storageMap_ = new Map();
        return Promise.resolve();
    }
    /**
   * @return {number}
   * @export
   */ get lastChange() {
        if (!$bd226c24ee4b7195$var$ls) return -1;
        let ts = $bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#ts");
        return ts ? parseInt($bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#ts"), 10) : Date.now();
    }
    /**
   * @return {number}
   */ get bytesUsed() {
        if (!$bd226c24ee4b7195$var$ls) return 0;
        const keys = Object.keys($bd226c24ee4b7195$var$ls || {}).filter((key)=>key.includes(this.storageKey_));
        const values = keys.map((key)=>$bd226c24ee4b7195$var$ls[key]);
        return new Blob(keys).size + new Blob(values).size;
    }
    /**
   * @return {number}
   * @export
   */ get usage() {
        return this.bytesUsed / $bd226c24ee4b7195$var$MAX_STORAGE_BYTES;
    }
    /**
   * @return {boolean}
   * @export
   */ get isLocalStorage() {
        return !!$bd226c24ee4b7195$var$ls;
    }
}
class $bd226c24ee4b7195$var$AxL {
    constructor(hostWindow = window.parent){
        /** @private @const {!Window} */ this.hostWindow_ = hostWindow;
        /** @private {?string} */ this.hostOrigin_ = null;
        /** @private @const {!Map<!AxL.HostToChild, !Function>} */ this.callbacks_ = new Map();
        /** @private {?Function} */ this.boundMessageHandler_ = null;
        /** @export {?AxLStorage} */ this.storage = null;
        const defaultHandshakeInterval = !!$bd226c24ee4b7195$var$SMLG ? $bd226c24ee4b7195$var$SMLG_HANDSHAKE_INTERVAL_MS : $bd226c24ee4b7195$var$HANDSHAKE_INTERVAL_MS;
        const params = new URLSearchParams(window.location.search);
        const hiOverrideParam = !!$bd226c24ee4b7195$var$SMLG ? "axlshi" : "axlhi";
        /** @private @const {number} */ this.handshakeInterval_ = parseInt(params.get(hiOverrideParam), 10) || defaultHandshakeInterval;
    }
    /**
   * Pings the host every 1000ms and returns a Promise that resolves when the
   * host responds. Call this when the app is ready to go.
   * @return {!Promise<!Object>}
   * @export
   */ handshake() {
        if ($bd226c24ee4b7195$var$LOCAL_DEV_MODE) return Promise.resolve({});
        let interval;
        const promise = new Promise((resolve, reject)=>{
            const handleGetResponse = (e)=>{
                if (!$bd226c24ee4b7195$var$isTrustedOrigin(e["origin"])) return;
                if (!e["data"] || e["data"]["type"] != $bd226c24ee4b7195$var$HOST_TO_CHILD_HANDSHAKE) return;
                try {
                    clearInterval(interval);
                    this.hostOrigin_ = e["origin"] || "*";
                    this.boundMessageHandler_ = (event)=>{
                        this.handleIncomingMessage_(event);
                    };
                    window.addEventListener("message", this.boundMessageHandler_);
                    window.removeEventListener("message", handleGetResponse);
                    // Retrieving system data.
                    const sysCmd = e["data"]["sys"];
                    if (e["data"]["id"]) {
                        const storageSendMessageCallback = (childToHostMessageType, payload)=>{
                            this.sendMessage(childToHostMessageType, payload);
                        };
                        let initHighScore = undefined;
                        let referralScore = undefined;
                        let highScoreData = undefined;
                        // Handling high scores data supplied by Stella in the system data.
                        if (sysCmd) {
                            $bd226c24ee4b7195$var$AxL.can["delegateSaving"] = !!sysCmd["ds"];
                            initHighScore = sysCmd["hs"];
                            referralScore = sysCmd["rs"];
                            highScoreData = sysCmd["hsd"];
                        }
                        this.storage = new $bd226c24ee4b7195$var$AxLStorage(e["data"]["id"], storageSendMessageCallback, initHighScore, referralScore, highScoreData);
                    }
                    if (sysCmd) {
                        if (sysCmd["fb"] && this.storage.lastChange < sysCmd["fb"]) this.storage.flush();
                        const capabilities = sysCmd["c"];
                        if (capabilities) {
                            $bd226c24ee4b7195$var$AxL.can["shareFiles"] = !!capabilities["sf"];
                            $bd226c24ee4b7195$var$AxL.can["download"] = !!capabilities["d"];
                            $bd226c24ee4b7195$var$AxL.can["useAltIcon"] = !!capabilities["uai"];
                            $bd226c24ee4b7195$var$AxL.can["sendFeedback"] = !!capabilities["f"];
                        }
                    }
                    resolve(e["data"]["payload"]);
                } catch (error) {
                    reject(error);
                }
            };
            window.addEventListener("message", handleGetResponse);
        });
        interval = setInterval(()=>{
            this.sendMessage($bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE, {
                "v": $bd226c24ee4b7195$var$API_VERSION
            });
        }, this.handshakeInterval_);
        return promise;
    }
    /**
   * Public method to send messages to the host along with optional data.
   * @param {!AxL.ChildToHost|string} childToHostMessageType
   * @param {?Object=} payload
   * @export
   */ sendMessage(childToHostMessageType, payload = null) {
        if (!this.hostOrigin_ && childToHostMessageType != $bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE) return;
        const message = {
            "type": childToHostMessageType,
            "payload": payload
        };
        if (!!$bd226c24ee4b7195$var$SMLG) $bd226c24ee4b7195$var$SMLG.postMessage(JSON.stringify(message));
        else this.hostWindow_.postMessage(message, this.hostOrigin_ || "*");
    }
    /**
   * Removes the incoming messages listener, clears any registered callback
   * and breaks the handshake.
   * @export
   */ dispose() {
        this.hostOrigin_ = null;
        this.boundMessageHandler_ && window.removeEventListener("message", this.boundMessageHandler_);
        this.callbacks_.clear();
    }
    /**
   * Registers a callback upon receiving a given Host message.
   * @param {!AxL.HostToChild} hostToChildMessageType
   * @param {!Function} callback
   * @export
   */ registerMessageCallback(hostToChildMessageType, callback) {
        this.callbacks_.set(hostToChildMessageType, callback);
    }
    /**
   * Private handler method for incoming messages.
   * @param {!Event} event
   * @private
   */ handleIncomingMessage_(event) {
        if (!$bd226c24ee4b7195$var$isTrustedOrigin(event["origin"])) return;
        if (!event["data"]) return;
        const callback = this.callbacks_.get(event["data"]["type"]);
        callback && callback(event["data"]["payload"]);
    }
}
/**
 * Indicates the framework and device capabilities. This is actually populated
 * when the handshake is completed.
 * @const {!Object<string, boolean>}
 */ $bd226c24ee4b7195$var$AxL.can = {
    "shareFiles": false,
    // Whether the SHARE message can accept files.
    "download": false,
    // Whether file download is supported on the platform.
    "useAltIcon": false,
    // True for iOS, for using appropriate share icons.
    "delegateSaving": false,
    // Whether saving data should be delegated to Stella.
    "sendFeedback": false // True if the GAC feedback feature is available.
};
// List of valid message types. Should match those defined by Stella.
/**
 * Events sent from the child (eg the game) to the host (eg Stella) of the
 * iframe.
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.ChildToHost = {
    "FEEDBACK": "f",
    "NAVIGATE": "n",
    "SET_URL_PARAMS": "p",
    "SHARE": "s",
    "TRACK": "t",
    "SAVE_HIGH_SCORE": "hs",
    "SAVE_HIGH_SCORE_FROM_LOCALSTORAGE": "hsl",
    "SAVE_GAME_STATE": "gs"
};
/**
 * Events sent from the host of the iframe (eg Stella) to the child (eg the
 * game).
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.HostToChild = {
    "FREEZE": "f",
    "RESUME": "r"
};
/**
 * Representation of the unit of the game's score.
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.ScoreUnit = {
    // Score represents an integer number of points.
    "POINTS": "p",
    // Score represents a time in milliseconds.
    "TIME_MILLIS": "tm",
    // Score represents a percentage of completion.
    "PERCENTAGE": "pc"
};
/** @const {number} */ $bd226c24ee4b7195$var$AxL.v = $bd226c24ee4b7195$var$API_VERSION;
var $bd226c24ee4b7195$export$2e2bcd8739ae039 = $bd226c24ee4b7195$var$AxL;


/*
from : http://en.wikipedia.org/wiki/Mersenne_twister
*/ let $08fa37fff71de28c$var$MT;
let $08fa37fff71de28c$var$index;
class $08fa37fff71de28c$var$prng {
    constructor(){
        this.setSeed(1);
    }
    setSeed(seed) {
        // Create a length 624 arrays to store the state of the generator
        $08fa37fff71de28c$var$MT = new Uint32Array(624);
        $08fa37fff71de28c$var$index = 0;
        $08fa37fff71de28c$var$MT[0] = seed;
        for(let i = 1; i < 624; i++)$08fa37fff71de28c$var$MT[i] = 1812433253 * ($08fa37fff71de28c$var$MT[i - 1] ^ ($08fa37fff71de28c$var$MT[i - 1] >> 30) + i);
    }
    extractNumber() {
        if ($08fa37fff71de28c$var$index === 0) this.generateNumbers();
        let y = $08fa37fff71de28c$var$MT[$08fa37fff71de28c$var$index];
        y = y ^ y >> 11;
        y = y ^ y << 7 & 2636928640;
        y = y ^ y << 15 & 4022730752;
        y = y ^ y >> 18;
        $08fa37fff71de28c$var$index = ($08fa37fff71de28c$var$index + 1) % 624;
        return y;
    }
    generateNumbers() {
        for(let i = 0; i < 624; i++){
            const y = ($08fa37fff71de28c$var$MT[i] & 0x80000000) + ($08fa37fff71de28c$var$MT[(i + 1) % 624] & 0x7fffffff);
            $08fa37fff71de28c$var$MT[i] = $08fa37fff71de28c$var$MT[(i + 397) % 624] ^ y >> 1;
            if (y % 2 !== 0) $08fa37fff71de28c$var$MT[i] = $08fa37fff71de28c$var$MT[i] ^ 2567483615;
        }
    }
    random() {
        return this.extractNumber() / 0x7fffffff;
    }
}
const $08fa37fff71de28c$export$20e67e28c05354ba = new $08fa37fff71de28c$var$prng();
class $08fa37fff71de28c$var$Scroll {
    constructor(){
        this._x = 0;
        this._y = 0;
    }
    set y(y) {
        this._y = y;
    }
    get y() {
        return this._y;
    }
    set x(x) {
        this._x = x;
    }
    get x() {
        return this._x;
    }
}
const $08fa37fff71de28c$export$209876d7b1ac8f3 = new $08fa37fff71de28c$var$Scroll();
async function $08fa37fff71de28c$export$22cb494f86e1e513(assetsList) {
    if (assetsList.length == 0) return {};
    const OG_DATA = {
        method: "POST",
        body: JSON.stringify({
            images: assetsList
        }),
        cache: "no-cache",
        headers: new Headers({
            "content-type": "application/json"
        })
    };
    return await fetch("./ogMultiple/", OG_DATA).then((data)=>{
        return data.json();
    }).then((json)=>{
        const imagesDict = {};
        json["items"].forEach((image)=>{
            imagesDict[image.id] = image.image.url;
        });
        return imagesDict;
    });
}
// determines which images are currently displayed on screen
// check if an image is in the viewport
function $08fa37fff71de28c$var$isInViewport(el) {
    const ww = window.innerWidth || document.documentElement.clientWidth;
    const wh = window.innerHeight || document.documentElement.clientHeight;
    const rect = el.getBoundingClientRect();
    if (rect.height > wh) return true;
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= wh && rect.right <= ww;
}
// check if a n image is fully outside the viewport
function $08fa37fff71de28c$var$isFullyOutsideViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom < 0 || rect.top > window.innerHeight;
}
function $08fa37fff71de28c$export$fa65b7c0510c5f90(query = ".wrapper .imagesWrapper") {
    const result = {
        inside: [],
        partial: [],
        outside: []
    };
    const images = document.querySelectorAll(query);
    images.forEach((image, index)=>{
        if ($08fa37fff71de28c$var$isInViewport(image)) result.inside.push(image);
        else if ($08fa37fff71de28c$var$isFullyOutsideViewport(image)) result.outside.push(image);
        else result.partial.push(image);
    });
    return result;
}
async function $08fa37fff71de28c$export$e7c8553478f3aac7(url) {
    return fetch(url).then((response)=>response.json());
}
function $08fa37fff71de28c$export$2b3abccb038db089() {
    // Tachyons breakpoints used for the css
    // @media screen and (min-width: 30em)
    const notSmallRule = "(min-width: 30em)";
    const isMobile = !window.matchMedia(notSmallRule).matches;
    return isMobile;
}
function $08fa37fff71de28c$export$125277f405055675() {
    // prevent infinite scroll to trigger while preloading stuff
    if (document.querySelector(".loader").classList.contains("hidden") === false) // console.log("nope!");
    return false;
    const scrollPosition = window.scrollY;
    const bodyHeight = document.documentElement.scrollHeight - window.innerHeight;
    return scrollPosition / bodyHeight > 0.8;
}
function $08fa37fff71de28c$export$3f99968195accfaf(top = 0, iOS = false) {
    if (iOS) window.scrollTo(0, top);
    else window.scrollTo({
        top: top,
        behavior: "smooth"
    });
}
function $08fa37fff71de28c$export$2fe57800cb27770e(str) {
    return str.trim().split(" ").map((s)=>{
        const a = s.split("");
        a[0] = a[0].toUpperCase();
        return a.join("");
    }).join(" ");
}


class $ea7e40a66df43b78$export$2e2bcd8739ae039 {
    constructor(json = null){
        this.assets = {};
        this.ocrs = {};
        this.ocrsList = [];
        this.gacLIst = [];
        this.tags = {};
        this.tagsScore = {};
        this.tagsList = [];
        this.categoriesList = [];
        this.categories = {};
        // this._svgList = [
        //   "./svg/1.svg",
        //   "./svg/2.svg",
        //   "./svg/3.svg",
        //   "./svg/3.svg",
        //   "./svg/4.svg",
        //   "./svg/5.svg",
        //   "./svg/6.svg",
        //   "./svg/7.svg",
        //   "./svg/8.svg",
        //   "./svg/9.svg",
        //   "./svg/10.svg",
        //   "./svg/11.svg",
        //   "./svg/12.svg",
        // ];
        this._svgList = [
            "./images/illustrations/1.png",
            "./images/illustrations/2.png",
            "./images/illustrations/4.png",
            "./images/illustrations/5.png",
            "./images/illustrations/6.png",
            "./images/illustrations/7.png",
            "./images/illustrations/8.png",
            "./images/illustrations/9.png",
            "./images/illustrations/10.png",
            "./images/illustrations/11.png",
            "./images/illustrations/12.png"
        ];
        if (json != null) this.parse(json);
    }
    get versoRecto() {
        return this._versoRecto;
    }
    //   LUT  = json/recto-verso.json
    set versoRecto(LUT) {
        this._versoRecto = LUT;
        // inverts the LUT to have a VERSO > RECTO table
        this._rectoVerso = {};
        for(let key in LUT)this._rectoVerso[LUT[key]] = key;
    }
    /**
   * builds revers LUT from the list of assets
   * @param {JSON is a dictionary of entries indexed by GACID} json
   */ parse(json) {
        // an entry:
        //     item.ocr : the ocr text
        //     item.tag : the tags list
        //     item.cat : the list of categories this item belongs to
        /*
    "ZAHPJLpCg-Atgg": 
    {
        "ocr": "NATIONAL MARKET PRODUCE SHOW AT OLYMPIA.\nPhoto ", 
        "tag": ["london", "olympia", "art library", ... ],
        "cat": ["/Arts & Entertainment", "/Food & Drink"]}
    */ Object.assign(this.assets, json);
        // store the categories
        for(let GAC_ID in json){
            const obj = json[GAC_ID];
            // store the texts
            this.ocrs[GAC_ID] = obj.ocr;
            this.ocrsList.push(obj.ocr);
            this.gacLIst.push(GAC_ID);
            // tags dictionary : tags[ tagName ] = [ assets IDS... ]
            obj.tag.forEach((tag)=>{
                // JS doesn't like this...
                if (tag == "constructor") return;
                if (tag == tag.toUpperCase()) return;
                // store the GAC_IDS list for this tag
                const key = tag.toLowerCase();
                if (this.tags[key] == undefined) this.tags[key] = [];
                this.tags[key].push(GAC_ID);
            });
            // categories dictionary : categories[ XXX ] = [ assets IDS... ]
            obj.cat.forEach((category)=>{
                // store the category name
                if (this.categoriesList.indexOf(category) == -1) this.categoriesList.push(category);
                // store items list
                if (this.categories[category] === undefined) this.categories[category] = [];
                this.categories[category].push(GAC_ID);
            });
        }
        // compute the tags score
        // exclude these: > 700 results ( TODO remove completely from JSON? )
        this.exclude = [
            "photograph",
            "copyright photograph",
            "daily herald",
            "FIRST PUBLICATION MONDAY",
            "FIRST PUBLICATION TUESDAY",
            "FIRST PUBLICATION WEDNESDAY",
            "FIRST PUBLICATION THURSDAY",
            "FIRST PUBLICATION FRIDAY",
            "FIRST PUBLICATION SATURDAY",
            "FIRST PUBLICATION SUNDAY",
            "PHOTO SHOWS",
            "PHOTOGRAPH SHOWS",
            "One",
            "titled",
            "caption",
            "back",
            "reads"
        ].map((s)=>s.toLowerCase());
        this.validTags = [];
        this.invalidTags = [];
        for(let tag in this.tags){
            const count = this.tags[tag].length;
            if (this.exclude.indexOf(tag.toLowerCase()) === -1 && tag != tag.toUpperCase()) {
                // stroe the score
                const key = tag.toLowerCase();
                if (this.tagsScore[key] == undefined) this.tagsScore[key] = 0;
                this.tagsScore[key] += count;
                // store the tag name
                this.tagsList.push(tag);
            } else {
                this.invalidTags.push(tag);
                delete this.tags[tag];
            }
        }
    // console.log("=> taglist", this.tagsList.length);
    }
    /**
   * selects assets list by category
   * @param { int || string } categories
   *    either a categories count : N categories will be picked at random
   *    or a category name : IùmageCount assets will be picked from this category
   * @param {*} imagesCount number of images per category
   * @returns
   */ getCategoriesContent(categories = 3, imagesCount = 10) {
        //is categories is a string, we need to scan only 1 category
        let categoriesCount = 1;
        // if categories is an number, we'll need 'categories' results
        const singleCategory = isNaN(categories);
        if (singleCategory == false) categoriesCount = categories;
        const imagesByCat = {};
        const randomCats = [];
        const versoIdsList = [];
        const tmpList = this.categoriesList.concat();
        // pick X random categories
        for(let i = 0; i < categoriesCount; i++){
            //
            // choose random category
            let categoryName = categories; //ok if categories is a string
            if (singleCategory == false) {
                const rnd = ~~((0, $08fa37fff71de28c$export$20e67e28c05354ba).random() * tmpList.length);
                categoryName = tmpList.splice(rnd, 1)[0];
            }
            const category = this.categories[categoryName];
            // store the category name
            randomCats.push(categoryName);
            // result object
            imagesByCat[categoryName] = [];
            //   choose random ids from this category
            const tmpCategory = category.concat();
            for(let j = 0; j < Math.min(category.length, imagesCount); j++){
                //
                // the index key is the GAC ID of the back of each image (verso)
                const rnd = ~~((0, $08fa37fff71de28c$export$20e67e28c05354ba).random() * tmpCategory.length);
                let verso = tmpCategory[rnd];
                tmpCategory.splice(rnd, 1);
                // populate result object and flat listflat
                imagesByCat[categoryName].push(verso);
                versoIdsList.push(verso);
            }
        }
        return {
            imagesByCat: imagesByCat,
            versoIdsList: versoIdsList
        };
    }
    // front and back of a GAC ID
    getAssetVerso(asset) {
        if (this._rectoVerso[asset] === undefined) return asset;
        return this._rectoVerso[asset];
    }
    getAssetRecto(asset) {
        if (this._versoRecto[asset] === undefined) return asset;
        return this._versoRecto[asset];
    }
    // asset text (OCR)
    getAssetText(asset) {
        return this.ocrs[asset].replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    // filtered asset tags list
    getAssetTags(asset) {
        // filter out invalid tags
        let tmp = this.assets[asset].tag.filter((tag)=>this.invalidTags.indexOf(tag) == -1 && tag != tag.toUpperCase());
        //sort tags by score
        tmp.sort((a, b)=>{
            return this.tagsScore[a.toLowerCase()] - this.tagsScore[b.toLowerCase()];
        });
        tmp.reverse();
        return tmp.map((tag)=>tag);
    }
    getRandomSVG() {
        return fetch(this._svgList[~~((0, $08fa37fff71de28c$export$20e67e28c05354ba).random() * this._svgList.length)]).then((response)=>response.text()).then((svg)=>svg);
    }
    getRandomPNG() {
        return fetch(this._svgList[~~((0, $08fa37fff71de28c$export$20e67e28c05354ba).random() * this._svgList.length)]).then((response)=>response.blob()).then((imageBlob)=>`<img src="${URL.createObjectURL(imageBlob)}" />`);
    }
}
const $ea7e40a66df43b78$export$1dc09377a991c7ad = new $ea7e40a66df43b78$export$2e2bcd8739ae039();


var $28edd11f6c7e9f5f$exports = {};
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;



let $af4794cc149d20b5$var$selection = [];
let $af4794cc149d20b5$var$edit_mode = false;
let $af4794cc149d20b5$var$interaction = true;
let $af4794cc149d20b5$var$hideShareIcon = true;
class $af4794cc149d20b5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    constructor(parent, versoId, scope = null){
        super();
        this.parent = parent;
        const bookmark = document.createElement("div");
        bookmark.classList.add("bookmark");
        parent.appendChild(bookmark);
        const icon = document.createElement("button");
        icon.setAttribute("tabindex", 1);
        icon.innerHTML = "bookmark";
        icon.classList.add("icon", "bookmarkSelector");
        icon.setAttribute("id", versoId);
        bookmark.appendChild(icon);
        // make icon clickable
        // console.warn(icon.parentNode.parentNode);
        if ($af4794cc149d20b5$export$2e2bcd8739ae039.selection.includes(versoId)) icon.classList.add("active");
        $af4794cc149d20b5$export$2e2bcd8739ae039.activateIcon(icon.parentNode.parentNode, scope);
    }
    static activateIcon(icon, scope = null) {
        icon.addEventListener("click", (e)=>{
            if ($af4794cc149d20b5$var$interaction) {
                // console.warn("click on image", e.target);
                let TARGET = e.target;
                if (e.target.tagName === "IMG") TARGET = e.target.parentNode.parentNode.parentNode.querySelector(".icon");
                if (TARGET.classList.contains("bookmarkSelector")) {
                    TARGET.classList.toggle("active");
                    const id = TARGET.getAttribute("id");
                    //   remove an item from page in 'edit mode'
                    if ($af4794cc149d20b5$var$edit_mode) {
                        const bookmarkElement = TARGET.parentNode;
                        const wrapper = bookmarkElement.parentNode;
                        const container = wrapper.parentNode;
                        container.removeChild(wrapper);
                        $af4794cc149d20b5$var$selection.splice($af4794cc149d20b5$var$selection.indexOf(id), 1);
                        if ($af4794cc149d20b5$var$selection.length == 0 && document.body.classList.contains("modern")) {
                            // Bookmark.emit("empty");
                            scope.bookmarks();
                            // window.scrollTo({ top: 0, behavior: "smooth" });
                            (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, scope.iOS());
                        }
                        if (scope.tracker) scope.tracker.track("BOOKMARK_REMOVE", id);
                    } else {
                        //   add remove to list in 'normal mode'
                        if (TARGET.classList.contains("active")) {
                            if ($af4794cc149d20b5$var$selection.indexOf(id) == -1) $af4794cc149d20b5$var$selection.push(id);
                            if (scope.tracker) scope.tracker.track("BOOKMARK_ADD", id);
                            scope.toolTips.showToolTipForAWhile(1, 2000);
                        } else if ($af4794cc149d20b5$var$selection.indexOf(id) != -1) {
                            $af4794cc149d20b5$var$selection.splice($af4794cc149d20b5$var$selection.indexOf(id), 1);
                            if ($af4794cc149d20b5$var$selection.length == 0 && document.body.classList.contains("modern")) {
                                // Bookmark.emit("empty");
                                scope.bookmarks();
                                // window.scrollTo({ top: 0, behavior: "smooth" });
                                (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, scope.iOS());
                            }
                            if (scope.tracker) scope.tracker.track("BOOKMARK_REMOVE", id);
                        }
                    }
                }
            }
        });
        const id = icon.getAttribute("id");
        icon.classList.remove("active");
        if ($af4794cc149d20b5$var$selection.indexOf(id) != -1) icon.classList.add("active");
    }
    static get selection() {
        return $af4794cc149d20b5$var$selection;
    }
    static set selection(val) {
        $af4794cc149d20b5$var$selection = val;
    }
    static get EDIT() {
        return $af4794cc149d20b5$var$edit_mode;
    }
    static set EDIT(value) {
        $af4794cc149d20b5$var$edit_mode = value;
    }
    static get INTERACTION() {
        return $af4794cc149d20b5$var$interaction;
    }
    static set INTERACTION(value) {
        $af4794cc149d20b5$var$interaction = value;
    }
    static set HIDE_SHARING(value) {
        $af4794cc149d20b5$var$hideShareIcon = value;
    }
    static get HIDE_SHARING() {
        return $af4794cc149d20b5$var$hideShareIcon;
    }
}





const $f0edfb206127a668$var$USE_COLOR = false;
var $3c416d133f8a7101$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



let $3c416d133f8a7101$var$url = new URL((parcelRequire("27Lyk")).resolve("ilX6d"), import.meta.url);
$3c416d133f8a7101$exports = $56b621a6dd25b2cb$exports($3c416d133f8a7101$var$url.toString(), $3c416d133f8a7101$var$url.origin, true);


class $f0edfb206127a668$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    constructor(url, asset_id, verso, useWorker = true, useBiggerSize = false){
        super();
        // check if we are in the modern version
        if (document.body.classList.contains("modern")) this.isModern = true;
        // console.log(verso);
        this.domElement = document.createElement("div");
        // console.log("IS USING COLOR", USE_COLOR);
        // add wrapper to carry 2 images
        const imagesWrapper = document.createElement("div");
        imagesWrapper.classList.add("imagesWrapper");
        imagesWrapper.classList.add(Math.random() > 0.5 ? "left" : "right");
        imagesWrapper.setAttribute("data-transition", "zoomed");
        imagesWrapper.setAttribute("data-verso", verso);
        this.domElement.appendChild(imagesWrapper);
        this.src = useWorker ? `${url}=s5` : url + useBiggerSize ? `${url}=s1024` : url;
        this.imagesWrapper = imagesWrapper;
        this.image = new Image();
        this.imagesWrapper.appendChild(this.image);
        // add color image on top overlay
        if ($f0edfb206127a668$var$USE_COLOR) {
            this.colorImage = new Image();
            this.colorImage.classList.add("colored");
            if (this.isModern) this.colorImage.classList.add("persistent");
            this.colorImage.src = `./getImage/${asset_id}`;
            imagesWrapper.appendChild(this.colorImage);
        } else this.image.classList.add("forceVisibility");
        if (useWorker && !this.isModern) this.loadSmoothly(url, useBiggerSize);
    // return domElement;
    }
    load(onComplete, onError = null) {
        this.image.onload = (e)=>{
            // console.table("\t\t image loaded");
            onComplete(e.target.src);
        // this.emit("loaded", [e.target.src]);
        };
        this.image.onerror = (e)=>{
            if (onError != null) onError(e.target.src);
        // this.emit("error", [e.target.src]);
        };
        this.image.src = this.src;
    }
    get dom() {
        return this.domElement;
    }
    loadSmoothly(url, useBiggerSize = false) {
        const loaderWorker = new Worker($3c416d133f8a7101$exports);
        loaderWorker.postMessage({
            url: url + (useBiggerSize ? `=s1024` : ``)
        });
        loaderWorker.onmessage = (event)=>{
            this.image.src = event.data;
        };
    }
}



class $a3d8d33dbed66be0$export$2e2bcd8739ae039 {
    constructor(asset_id){
        const tags = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getAssetTags(asset_id).filter((tag)=>{
            const count = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsScore[tag];
            return (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsScore[tag] != undefined && count > 4 && count < 100;
        });
        this.tags = [];
        this.domElement = document.createElement("div");
        this.domElement.classList.add("relatedTopics");
        this.headline = document.createElement("div");
        this.headline.classList.add("tags");
        this.headline.classList.add("tags-headline");
        this.headline.innerHTML = "RELATED TOPICS";
        this.domElement.appendChild(this.headline);
        this.tagsContainer = document.createElement("div");
        this.tagsContainer.classList.add("tags");
        this.domElement.appendChild(this.tagsContainer);
        // tags retrieved from the JSON
        this.tags = [];
        // console.log(tags);
        tags.forEach((tag, i)=>{
            const link = document.createElement("button");
            const count = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsScore[tag];
            link.textContent = tag + " (" + count + ")";
            link.classList.add("tag");
            link.style.opacity = 1;
            link.tag = tag;
            link.setAttribute("tag", tag);
            link.setAttribute("tabindex", 1);
            this.tagsContainer.appendChild(link);
            this.tags.push(link);
        });
    }
}







class $89766f1614cc8ce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    constructor(container, category, imagesDict, imagesByCat, USE_WORKER, index, isBookmark, scope){
        super();
        this.container = container;
        this.USE_WORKER = USE_WORKER;
        this.imagesByCat = imagesByCat;
        this.imagesDict = imagesDict;
        this.category = category;
        this.headline = category;
        this.isBookmark = isBookmark;
        this.axl = scope.axl;
        this.scope = scope;
        this.newContainer = document.createElement("div");
        // pool of images to load
        this.pool = [];
        // collection of tags
        this.tags = [];
        this.handlers = {
            share: this.onShare.bind(this)
        };
        //random distribution of images
        let rnd = 0.4;
        // rnd = Math.random();
        // Base on the index we use a different layout
        //  0.4 means the regular 3 columns
        //  0.6 means the 2 columns with one double on the left
        //  0.8 means the 2 columns with one double on the right
        // we try to alternate the layout
        if (index % 4 == 0) rnd = 0.4;
        if (index % 4 == 1) rnd = 0.6;
        if (index % 4 == 2) rnd = 0.4;
        if (index % 4 == 3) rnd = 0.8;
        //special cases
        // if there is a single image in the category we use the double layout
        // if there is 2 images in the category we use the 2 columns layout with a big one on the right
        // if there is 3 images in the category we use the 3 columns layout
        if (this.imagesByCat[this.category].length == 1) rnd = 0.6;
        if (this.imagesByCat[this.category].length == 2) rnd = 0.8;
        if (this.imagesByCat[this.category].length == 3) rnd = 0.4;
        // the switch is also set for a random distribution
        if ((0, $08fa37fff71de28c$export$2b3abccb038db089)()) this.setContent();
        else switch(true){
            case rnd > 0.75:
                this.setMasonryContent(1);
                break;
            case rnd > 0.5:
                this.setMasonryContent(0);
                break;
            default:
                this.setContent();
        }
    }
    set headline(val) {
        const headline = document.createElement("h2");
        headline.innerHTML = val.split("/").join("<br/>").slice(5).toUpperCase();
        this._headline = headline;
    }
    get headline() {
        if (this.isBookmark) {
            const shareWrapper = document.createElement("div");
            shareWrapper.classList.add("personalShare");
            shareWrapper.innerHTML = `share`;
            if (!(0, $af4794cc149d20b5$export$2e2bcd8739ae039).HIDE_SHARING) shareWrapper.classList.add("show");
            const span = document.createElement("span");
            span.classList.add("material-icons");
            span.textContent = "share";
            shareWrapper.addEventListener("click", this.handlers.share);
            shareWrapper.appendChild(span);
            this._headline.appendChild(shareWrapper);
        // this._headline += `<span class="material-icons share">share</span>`;
        }
        return this._headline;
    }
    get detail() {
        return this._detail;
    }
    async setImageLayout() {
        this.newContainer.classList.add(this.isMasonry ? "masonry" : "content");
        // get the images for this category
        const images = this.imagesByCat[this.category];
        // imagesDict is index with RECTO images
        let subWrapper = null;
        // pool of images to load
        this.pool = [];
        // collection of tags
        this.tags = [];
        images.forEach((verso, i)=>{
            const recto = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getAssetRecto(verso);
            // remove that condition as we don't use the recto anymore
            if (this.imagesDict[recto]) {
                //
                const wrapper = document.createElement("div");
                wrapper.classList.add("wrapper");
                // add image
                // console.log(recto);
                const view = new (0, $f0edfb206127a668$export$2e2bcd8739ae039)(this.imagesDict[recto], recto, verso, this.USE_WORKER, true);
                wrapper.appendChild(view.dom);
                // add a clickable BOOKMARK button
                new (0, $af4794cc149d20b5$export$2e2bcd8739ae039)(view.dom, verso, this.scope);
                // add image to queue
                this.pool.push(view);
                // TODO fix link
                const gac_link = document.createElement("button");
                gac_link.classList.add("gac-link");
                gac_link.classList.add("material-icons");
                gac_link.setAttribute("tabindex", 1);
                gac_link.innerHTML = "open_in_new";
                const url = `asset/${(0, $ea7e40a66df43b78$export$1dc09377a991c7ad).assets[verso].par}?childassetid=${recto}`;
                gac_link.setAttribute("url", url);
                gac_link.addEventListener("click", (e)=>{
                    e.preventDefault();
                    (0, $08fa37fff71de28c$export$209876d7b1ac8f3).y = window.scrollY;
                    const url = e.target.getAttribute("url");
                    this.axl.sendMessage((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).ChildToHost.NAVIGATE, url);
                });
                wrapper.append(gac_link);
                // const link = document.createElement("a");
                // link.setAttribute("value", recto);
                // link.innerHTML = "open_in_new";
                // gac_link.append(link);
                // add text
                const sentenceElement = document.createElement("p");
                sentenceElement.classList.add("sentence");
                let text = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getAssetText(verso); // .replace( /<br>/g, " " );
                sentenceElement.innerHTML = text;
                wrapper.appendChild(sentenceElement);
                //test if the tags should be displayed
                const tags = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getAssetTags(verso).filter((tag)=>{
                    const count = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsScore[tag];
                    return (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsScore[tag] != undefined && count > 4 && count < 100;
                });
                if (tags.length != 0) {
                    const tags = new (0, $a3d8d33dbed66be0$export$2e2bcd8739ae039)(verso);
                    wrapper.appendChild(tags.domElement);
                }
                if (this.isMasonry) {
                    if (this.n == 0) {
                        if (i % 5 == 0) {
                            this.columns[0].appendChild(wrapper);
                            subWrapper = document.createElement("div");
                            subWrapper.classList.add("subWrapper");
                            wrapper.appendChild(subWrapper);
                        } else if (i % 5 == 2 || i % 5 == 3) subWrapper.appendChild(wrapper);
                        else if (i % 5 == 1 || i % 5 == 4) this.columns[1].appendChild(wrapper);
                    } else {
                        if (i % 5 == 1 && i != 0) {
                            this.columns[1].appendChild(wrapper);
                            subWrapper = document.createElement("div");
                            subWrapper.classList.add("subWrapper");
                            wrapper.appendChild(subWrapper);
                        } else if (i % 5 == 3 || i % 5 == 4) subWrapper.appendChild(wrapper);
                        else if (i == 0 || i % 5 == 0 || i % 5 == 2) this.columns[0].appendChild(wrapper);
                    }
                } else this.newContainer.appendChild(wrapper);
            }
        });
    }
    async resize() {
        if (document.body.classList.contains("modern")) this.isModern = true;
        else this.isModern = false;
        if (this.isMasonry && !this.isModern) {
            //remove previous SVGs
            let column1Height = 42; //default margins
            Array.from(this.columns[0].children).forEach((wrapper)=>{
                // console.log(wrapper);
                column1Height += wrapper.offsetHeight;
            });
            let column2Height = 42; //default margins
            Array.from(this.columns[1].children).forEach((wrapper)=>{
                column2Height += wrapper.offsetHeight;
            });
            const limit = 150;
            if (column1Height < column2Height - limit && !this.svg) {
                this.svg = document.createElement("div");
                this.svg.classList.add("svg");
                // this.svg.innerHTML = await DATA_STORE.getRandomSVG();
                this.svg.innerHTML = await (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getRandomPNG();
                this.columns[0].appendChild(this.svg);
                this.columns[0].getElementsByClassName("svg")[0].style.maxHeight = `${column2Height - column1Height - 20}px`;
            } else if (column2Height < column1Height - limit && !this.svg) {
                this.svg = document.createElement("div");
                this.svg.classList.add("svg");
                // this.svg.innerHTML = await DATA_STORE.getRandomSVG();
                this.svg.innerHTML = await (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getRandomPNG();
                this.columns[1].appendChild(this.svg);
                this.columns[1].getElementsByClassName("svg")[0].style.maxHeight = `${column1Height - column2Height - 20}px`;
            }
            //  !! SVG COULD CHANGE COLUMN..... SO CHECK AGAIN
            if (Math.abs(column1Height - column2Height) < limit && this.svg) this.svg.classList.add("hidden");
            else if (this.svg) try {
                this.svg.classList.remove("hidden");
                this.svg.getElementsByClassName("svg")[0].style.maxHeight = `${Math.abs(column1Height - column2Height) - 20}px`;
            } catch (err) {}
        }
    }
    setMasonryContent(n) {
        this.n = n;
        this.columns = [];
        this.isMasonry = true;
        // create n flex colunms
        for(let i = 0; i < 2; i++){
            const column = document.createElement("div");
            column.classList.add("flex-column");
            if (i == n) column.classList.add("double");
            this.newContainer.appendChild(column);
            this.columns.push(column);
        }
        // this.headline = this.category;
        this.columns[0].appendChild(this.headline);
        this.setImageLayout();
    }
    setContent() {
        // this.headline = this.category;
        this.newContainer.appendChild(this.headline);
        this.setImageLayout();
    }
    onShare() {
        if (this.axl && (0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection.length > 0) {
            this.axl.sendMessage((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).ChildToHost.SET_URL_PARAMS, {
                bookmarks: (0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection
            });
            this.axl.sendMessage((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).ChildToHost.SHARE, {
                title: "Discover my personal edition of the Daily Herald made with @googlearts and @MediaMuseum"
            });
            this.scope.tracker.track("SHARE");
        }
    }
    load() {
        // no more images to load
        if (this.pool.length == 0) {
            this.emit("content-loaded-before", this);
            this.container.appendChild(this.newContainer);
            this.emit("content-loaded", this);
            return;
        }
        // prelaod an image
        const view = this.pool.shift();
        view.load(async ()=>{
            // console.log(
            //   "view loaded ",
            //   this.category,
            //   ":",
            //   this.pool.length,
            //   "images left"
            // );
            this.emit("image-loaded");
            this.load();
        }, (err)=>{
            this.load();
        });
        return;
    }
}





const $a410f6417454fa4f$var$dp = new DOMParser();
let $a410f6417454fa4f$var$MAX_RESULT;
let $a410f6417454fa4f$var$values, $a410f6417454fa4f$var$searchField, $a410f6417454fa4f$var$searchFieldDefault, $a410f6417454fa4f$var$resultsContainer, $a410f6417454fa4f$var$resultsList;
class $a410f6417454fa4f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    constructor(maxresults = 10){
        super();
        $a410f6417454fa4f$var$resultsList = [];
        $a410f6417454fa4f$var$MAX_RESULT = maxresults;
        $a410f6417454fa4f$var$values = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tagsList.concat();
        // container for search
        // this.container = document.querySelector(".price");
        // this.searchWrapper = document.createElement("div");
        // this.searchWrapper.classList.add("search-wrapper");
        // this.container.appendChild(this.searchWrapper);
        // // create search field
        // let html = `<div class="search-wrapper">
        //       <div class="search-form">
        //         <div class="search-field-default">search the collection <span class="material-icons lens">search</span></div>
        //         <input class="search-field" tabindex="0">
        //       </div></div>`;
        // let element = dp.parseFromString(html, "text/html").body.children[0];
        // this.element = element;
        // // document.body.appendChild(element);
        // document.body.insertBefore(element, document.body.firstChild);
        // // this.searchWrapper.appendChild(element);
        this.search_wrapper = document.querySelector(".search-wrapper");
        // hook the search
        $a410f6417454fa4f$var$searchField = document.querySelector(".search-field");
        $a410f6417454fa4f$var$searchField.setAttribute("tabindex", 1);
        $a410f6417454fa4f$var$searchFieldDefault = document.querySelector(".search-field-default");
        $a410f6417454fa4f$var$searchField.addEventListener("pointerdown", (e)=>{
            if ($a410f6417454fa4f$var$searchField.value.trim() != "") this.search($a410f6417454fa4f$var$searchField.value);
        });
        $a410f6417454fa4f$var$searchField.addEventListener("keydown", (e)=>{
            if ($a410f6417454fa4f$var$searchField.value.trim() === "") this.clearResults();
            else $a410f6417454fa4f$var$searchFieldDefault.classList.add("hidden");
            // jump to first result with arrow down
            if (e.key == "Tab" || e.key == "ArrowDown") {
                if ($a410f6417454fa4f$var$resultsList.length > 0) $a410f6417454fa4f$var$resultsList[0].focus();
                e.preventDefault();
                e.target.blur();
            }
        });
        $a410f6417454fa4f$var$searchField.addEventListener("keyup", (e)=>{
            if ($a410f6417454fa4f$var$searchField.value.trim() === "") {
                this.clearResults();
                return;
            }
            $a410f6417454fa4f$var$searchFieldDefault.classList.add("hidden");
            this.search($a410f6417454fa4f$var$searchField.value);
            // perform a search on all ocr texts
            if (e.key == "Enter") {
                if ($a410f6417454fa4f$var$searchField.value.trim() == "") return;
                const result = this.searchOCR($a410f6417454fa4f$var$searchField.value);
                $a410f6417454fa4f$var$resultsContainer.classList.add("hidden");
                this.emit("select", $a410f6417454fa4f$var$searchField.value, result, "search");
                this.clearResults();
                e.preventDefault();
            }
        });
        window.addEventListener("click", (e)=>{
            if (e.target != $a410f6417454fa4f$var$searchField && e.target != $a410f6417454fa4f$var$resultsContainer) this.clearResults();
        });
        //   result list
        $a410f6417454fa4f$var$resultsContainer = document.createElement("div");
        $a410f6417454fa4f$var$resultsContainer.classList.add("search-result");
        this.search_wrapper.appendChild($a410f6417454fa4f$var$resultsContainer);
        //get top position for resultsContainer
        const top = $a410f6417454fa4f$var$resultsContainer.offsetTop + 40;
        $a410f6417454fa4f$var$resultsContainer.style.maxHeight = `${window.innerHeight - top}px`;
        // this.searchWrapper.appendChild(resultsContainer);
        // keyboard handling
        $a410f6417454fa4f$var$resultsContainer.addEventListener("keydown", (e)=>{
            if (e.key == "Enter") {
                this.selectResult(e);
                e.preventDefault();
            }
            if (e.key == "ArrowDown" || e.key == "ArrowUp") {
                const el = document.activeElement;
                const tab = el.getAttribute("tabindex");
                let index = $a410f6417454fa4f$var$resultsList.indexOf(el);
                if (e.key == "ArrowDown") index = (index + 1) % $a410f6417454fa4f$var$resultsList.length;
                if (e.key == "ArrowUp") {
                    // loop on list
                    // index = index - 1 < 0 ? resultsList.length - 1 : index - 1;
                    // move back to searchfield
                    index -= 1;
                    if (index < 0) {
                        $a410f6417454fa4f$var$searchField.focus();
                        return e.preventDefault();
                    }
                }
                $a410f6417454fa4f$var$resultsList[index].focus();
                e.preventDefault();
            }
        });
        this.clearResults();
    }
    // find ten "best" results
    searchOCR(searchTerm) {
        const regex = new RegExp(`${searchTerm}`, "gi");
        let scores = [];
        (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).ocrsList.forEach((str, i)=>{
            let count = (str.match(regex) || []).length;
            scores.push({
                score: count,
                id: i,
                gacid: (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).gacLIst[i]
            });
        });
        scores.sort((a, b)=>{
            return a.score - b.score;
        });
        scores.reverse();
        let tmp = [];
        for(let i = 0; i < scores.length; i++){
            if (scores[i].score <= 0) break;
            tmp.push(scores[i].gacid);
        }
        return tmp;
    }
    // https://stackoverflow.com/questions/43393136/js-create-smart-auto-complete
    search(searchTerm) {
        let inp = $a410f6417454fa4f$var$sanitize(searchTerm);
        if (inp.length == 0) {
            results.classList.add("hidden");
            return;
        }
        let results = $a410f6417454fa4f$var$values.filter((s)=>$a410f6417454fa4f$var$fuzzyMatch(s, inp));
        results.sort((a, b)=>{
            return $a410f6417454fa4f$var$getEditDistance(a, inp) - $a410f6417454fa4f$var$getEditDistance(b, inp);
        });
        $a410f6417454fa4f$var$resultsList = [];
        results = results.slice(0, $a410f6417454fa4f$var$MAX_RESULT).map((r)=>(0, $08fa37fff71de28c$export$2fe57800cb27770e)(r));
        if (results.length == 0) {
            $a410f6417454fa4f$var$resultsContainer.classList.add("hidden");
            return;
        }
        searchTerm = (0, $08fa37fff71de28c$export$2fe57800cb27770e)(searchTerm);
        results = results.map((input, i)=>{
            let formatted = "";
            //highlight some characters in the sentence
            if (input.lastIndexOf(searchTerm) == -1) {
                let id = 0;
                for(let i = 0; i < input.length; i++)if (input.charAt(i) == searchTerm.charAt(id)) {
                    formatted += `<span class="highlight-letter">${input.charAt(i)}</span>`;
                    id++;
                } else formatted += input.charAt(i);
            } else {
                //highlight the whole sentence
                let id = input.lastIndexOf(searchTerm);
                formatted = input.substr(0, id) + `<span class="highlight-letter">${input.substr(id, searchTerm.length)}</span>` + input.substr(id + searchTerm.length, input.length);
            }
            return formatted;
        });
        return this.updateList(results);
    }
    updateList(res) {
        //clear the list
        while($a410f6417454fa4f$var$resultsContainer.children.length)$a410f6417454fa4f$var$resultsContainer.removeChild($a410f6417454fa4f$var$resultsContainer.children[0]);
        // create list of clickable results
        res.forEach((o, i)=>{
            const resultItem = this.createResultElement(o);
            resultItem.setAttribute("tabindex", 1 + i);
            resultItem.addEventListener("focusin", (e)=>{
                e.target.classList.add("selected");
            });
            resultItem.addEventListener("focusout", (e)=>{
                e.target.classList.remove("selected");
            });
            resultItem.addEventListener("click", this.selectResult.bind(this));
            $a410f6417454fa4f$var$resultsContainer.appendChild(resultItem);
            $a410f6417454fa4f$var$resultsList.push(resultItem);
        });
        $a410f6417454fa4f$var$resultsContainer.classList.remove("hidden");
    }
    //result item
    createResultElement(text) {
        const html = `
            <div class="search-result-item">
                <span class="text">${text}</span>
            </div>`;
        return $a410f6417454fa4f$var$dp.parseFromString(html, "text/html").body.children[0];
    }
    selectResult(e) {
        $a410f6417454fa4f$var$resultsContainer.classList.add("hidden");
        const resultItem = e.target;
        const tag = resultItem.innerText.trim().toLowerCase();
        $a410f6417454fa4f$var$searchField.value = tag;
        this.emit("select", tag, (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tags[tag], "tag");
    }
    clearResults() {
        let tmp = [];
        $a410f6417454fa4f$var$searchFieldDefault.classList.remove("hidden");
        $a410f6417454fa4f$var$searchField.value = "";
        while($a410f6417454fa4f$var$resultsContainer.children.length){
            tmp.push($a410f6417454fa4f$var$resultsContainer.children[0]);
            $a410f6417454fa4f$var$resultsContainer.removeChild($a410f6417454fa4f$var$resultsContainer.children[0]);
        }
        $a410f6417454fa4f$var$resultsContainer.classList.add("hidden");
        return tmp;
    }
}
// levenshtein distance : https://gist.github.com/andrei-m/982927
/*
Copyright (c) 2011 Andrei Mackenzie
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ // Compute the edit distance between the two given strings
function $a410f6417454fa4f$var$getEditDistance(a, b) {
    if (a.length == 0) return b.length;
    if (b.length == 0) return a.length;
    var matrix = [];
    // increment along the first column of each row
    var i;
    for(i = 0; i <= b.length; i++)matrix[i] = [
        i
    ];
    // increment each column in the first row
    var j;
    for(j = 0; j <= a.length; j++)matrix[0][j] = j;
    // Fill in the rest of the matrix
    for(i = 1; i <= b.length; i++){
        for(j = 1; j <= a.length; j++)if (b.charAt(i - 1) == a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
        Math.min(matrix[i][j - 1] + 1, // insertion
        matrix[i - 1][j] + 1)); // deletion
    }
    return matrix[b.length][a.length] + a.length;
}
// sanitize input text
function $a410f6417454fa4f$var$sanitize(str) {
    return str.trim().toLowerCase().replace(/[^\w\s\']|_/g, "") //alphanumeric only
    .replace(/\s+/g, ""); // no spaces
}
// MAGIC
function $a410f6417454fa4f$var$fuzzyMatch(s, p) {
    p = p.split("").reduce((a, b)=>a + "[^" + b + "]*" + b);
    return RegExp(p, "i").test(s);
}







class $188b8eb0b6a89e49$export$2e2bcd8739ae039 extends (0, $28edd11f6c7e9f5f$exports.EventEmitter) {
    constructor(container, imagesByCat){
        super();
        // special case: empty search result
        const cats = imagesByCat;
        const keys = Object.keys(cats);
        const element = document.createElement("div");
        container.appendChild(element);
        const msg = "<br><br>Sorry, we could not find any images using your search term, either try again or click below to explore more of the archive.<br>";
        const headline = document.createElement("h2");
        headline.classList.add("searchMessage");
        headline.innerHTML = keys[0].split("/").join("<br/>").slice(5).toUpperCase() + msg;
        element.appendChild(headline);
        let parent = document.createElement("div");
        element.appendChild(parent);
        const DICT = {};
        (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).categoriesList.forEach((cat)=>{
            if (cat.lastIndexOf("Internet") != -1) return;
            if (cat == "/Sensitive Subjects") return;
            if (cat == "/Adult") return;
            const root = cat.split("/")[1];
            if (DICT[root] === undefined) DICT[root] = [];
            if (cat.split("/").length > 2) DICT[root].push(cat);
        });
        for(let key in DICT){
            let link = document.createElement("a");
            link.classList.add("catagory-link");
            link.innerText = key;
            link.addEventListener("pointerup", ()=>{
                let candidates = [];
                DICT[key].forEach((name)=>{
                    candidates = candidates.concat((0, $ea7e40a66df43b78$export$1dc09377a991c7ad).categories[name]);
                });
                const total = candidates.length;
                const assets = [];
                for(let i = 0; i < total; i++){
                    const cn = DICT[key][~~(Math.random() * DICT[key].length)];
                    const ar = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).categories[cn];
                    let na = ar[~~(Math.random() * ar.length)];
                    assets.push(na);
                }
                this.emit("select", key, assets);
            });
            parent.appendChild(link);
        }
    }
}


let $abbe520c4a11007c$var$CONTAINER, $abbe520c4a11007c$var$SAVED;
class $abbe520c4a11007c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports))) {
    constructor(USE_WORKER = false, axl = null, tracker = null, tooltips = null){
        super();
        //use workers ?
        this.USE_WORKER = USE_WORKER;
        this.axl = axl;
        this.tracker = tracker;
        this.toolTips = tooltips;
        // preloading
        this.loading = false;
        this.pool = [];
        this.handlers = {
            onFirstContentLoaded: this.onFirstContentLoaded.bind(this),
            onLodComplete: this.onLodComplete.bind(this),
            onProgress: this.onProgress.bind(this)
        };
        //start loop
        this.visibilityCheck(); //TODO : freeze on Axl FREEZE
        // searchfield
        this.search = new (0, $a410f6417454fa4f$export$2e2bcd8739ae039)();
        this.search.on("select", (tag, assets, type)=>{
            this.emit("search-result", tag, assets, type);
        });
        // builds a container
        $abbe520c4a11007c$var$CONTAINER = document.createElement("div");
        //listen to tag clicks
        $abbe520c4a11007c$var$CONTAINER.addEventListener("click", (e)=>{
            if (e.target.classList.contains("tag") == true) {
                const tag = e.target.getAttribute("tag");
                this.emit("tag-clicked", tag);
            }
        });
        document.querySelector(".letter").appendChild($abbe520c4a11007c$var$CONTAINER);
        // save/restore state
        $abbe520c4a11007c$var$SAVED = "";
        // keep ref for each content
        this.contents = [];
    }
    iOS() {
        return [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform) || // iPad on iOS 13 detection
        navigator.userAgent.includes("Mac") && "ontouchend" in document;
    }
    // remove all the children
    clear() {
        const e = $abbe520c4a11007c$var$CONTAINER;
        while(e.children.length)e.removeChild(e.children[0]);
    }
    saveState() {
        $abbe520c4a11007c$var$SAVED = $abbe520c4a11007c$var$CONTAINER.innerHTML;
    }
    restoreState() {
        this.clear();
        $abbe520c4a11007c$var$CONTAINER.innerHTML = $abbe520c4a11007c$var$SAVED;
        // this.resetTagListeners();
        this.resetGacLinkListeners();
        const bookmarks = $abbe520c4a11007c$var$CONTAINER.querySelectorAll(".bookmark");
        for (let book of bookmarks){
            const icon = book.querySelector(".icon");
            if ((0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection.includes(icon.getAttribute("id"))) icon.classList.add("active");
            else icon.classList.remove("active");
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).activateIcon(icon.parentNode.parentNode, this);
        }
        (0, $af4794cc149d20b5$export$2e2bcd8739ae039).HIDE_SHARING = false;
    }
    resize() {
        this.contents.forEach((content)=>{
            content.resize();
        });
    }
    async introduction(clear = false) {
        // write the current week day in the date div
        if (clear) this.clear();
        const date = document.querySelector(".date");
        const dateStr = new Date().toLocaleDateString("en-US", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric"
        });
        date.textContent = `${dateStr}`;
        if (!clear && !this.introContent) // fetch the introduction content
        this.introContent = await (0, $08fa37fff71de28c$export$e7c8553478f3aac7)("./json/presentation.json");
        // build intro
        const newContainer = document.createElement("div");
        newContainer.classList.add("introduction");
        this.introContent.introduction.forEach((text, index)=>{
            // if (index == this.introContent.introduction.length - 1) {
            //   const ads = document.createElement("span");
            //   ads.classList.add("ads");
            //   ads.textContent = text;
            //   newContainer.appendChild(ads);
            // } else {
            // }
            newContainer.innerHTML += text + (index < this.introContent.introduction.length - 1 ? "<hr/>" : "");
        });
        $abbe520c4a11007c$var$CONTAINER.appendChild(newContainer);
    }
    // Bookmark instructions
    bookmarks() {
        if ((0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection.length == 0) {
            this.clear();
            // display instructions
            const text = `Bookmark photos from the Daily Herald Archive to curate your own special edition. The photos you select will appear here. 
      When you are ready click share to allow others to enjoy your personalised edition of the newspaper.`;
            const headline = document.createElement("h2");
            headline.innerHTML = text.replace(/\n/g, "<br>");
            $abbe520c4a11007c$var$CONTAINER.appendChild(headline);
        } else {
            // display an assets list
            const title = (0, $af4794cc149d20b5$export$2e2bcd8739ae039).HIDE_SHARING ? "Special edition" : "My Personal Edition";
            this.assets(title, (0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection.concat(), true, true);
        }
    }
    /**
   * categories is either a NUMBER of random categories
   * OR the NAME of a category
   *
   * get 3 catgeories
   *    categories = 3;
   *
   * get the "/Beauty & Fitness/Beauty Pageants" category
   *    categories = "/Beauty & Fitness/Beauty Pageants",
   *
   * how many images from this category
   *    imagesCount = 10;
   * @param {int|string} categories count or category name
   * @param {int} imagesCount int
   */ async categories(categories = 10, imagesCount = 10, clear = false) {
        const { imagesByCat: imagesByCat, versoIdsList: versoIdsList } = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getCategoriesContent(categories, imagesCount);
        await this.createContent(imagesByCat, versoIdsList, clear);
        // to avoid reloading content with infinite scroll
        this.notReady = true;
    }
    /**
   * builds a content block based on a tag
   * @param {string} tag
   */ async tags(tag, clear = true) {
        const assets = (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).tags[tag];
        // const maxTAG = 50;
        // assets = assets.slice(
        //   0,
        //   Math.min(DATA_STORE.tags[tag].length, maxTAG)
        // );
        const imagesDictionary = {};
        imagesDictionary["/" + tag] = assets;
        await this.createContent(imagesDictionary, assets, clear);
    }
    /**
   * builds a content block based on a name and a series of asset ids
   * @param {string} name
   * @param {Array} assets
   */ async assets(name, assets, clear = true, isBookmark = false) {
        const imagesDictionary = {};
        imagesDictionary["/" + name] = assets;
        await this.createContent(imagesDictionary, assets, clear, isBookmark);
    }
    // builds a Content object
    async createContent(imagesByCat, versoIdsList, clear = false, isBookmark) {
        if (this.loading == true) return;
        this.loading = true;
        // clear the preload pool
        this.pool.forEach((content)=>{
            content.off("content-loaded-before", this.handlers.onFirstContentLoaded);
            content.off("content-loaded", this.handlers.onLodComplete);
            content.off("image-loaded", this.handlers.onProgress);
        });
        this.pool = [];
        // special case: empty search result
        const cats = imagesByCat;
        const keys = Object.keys(cats);
        const isEmptySearchResult = keys.length == 1 && cats[keys[0]].length == 0;
        if (isEmptySearchResult) {
            this.clear();
            let empty = new (0, $188b8eb0b6a89e49$export$2e2bcd8739ae039)($abbe520c4a11007c$var$CONTAINER, imagesByCat);
            empty.on("select", (name, assets)=>{
                this.emit("search-result", name, assets, "search");
            });
            this.loading = false;
            return;
        }
        // convert VERSO ID to RECTO ID
        const rectoIds = versoIdsList.map((verso)=>(0, $ea7e40a66df43b78$export$1dc09377a991c7ad).getAssetRecto(verso));
        // create a dictionary of images images[ recto GAC_ID ] => image URL
        const imagesDict = await (0, $08fa37fff71de28c$export$22cb494f86e1e513)(rectoIds);
        //once the URLS have arrived clears the page if need be (tags)
        // if (clear == true) {
        //   this.clear();
        // }
        // // delegated after laoding
        this.cleared = false;
        this.mustClear = clear;
        // create chapters by category with the related images
        // get categories keys
        const categoriesKeys = Object.keys(imagesByCat);
        // create chapters
        this.contentToBeLoaded = categoriesKeys.length;
        this.totalImages = 0;
        categoriesKeys.forEach((category, i)=>{
            const content = new (0, $89766f1614cc8ce3$export$2e2bcd8739ae039)($abbe520c4a11007c$var$CONTAINER, category, imagesDict, imagesByCat, this.USE_WORKER, i, isBookmark, this);
            this.pool.push(content);
            this.contents.push(content);
            this.totalImages += content.pool.length;
        });
        // load all the contents
        this.loadedImages = 0;
        document.querySelector(".progress").innerHTML = "";
        this.onProgress();
        this.completed = false;
        this.load();
    }
    // resetTagListeners() {
    //   // let tagElements = document
    //   //   .querySelector(".letter")
    //   //   .querySelectorAll(".tag");
    //   // const callback = this.onTagClicked.bind(this);
    //   // let index = 0;
    //   // for (let tag of tagElements) {
    //   //   tag.removeEventListener("pointerdown", callback);
    //   //   tag.addEventListener("pointerdown", callback);
    //   //   setTimeout(() => {
    //   //     tag.style.opacity = 1;
    //   //   }, 500 + index * 100);
    //   //   index++;
    //   // }
    // }
    // onTagClicked(e) {
    //   const tag = e.target.getAttribute("tag");
    //   this.emit("tag-clicked", tag);
    // }
    resetGacLinkListeners() {
        let gac_links = document.querySelector(".letter").querySelectorAll(".gac-link");
        for (let gac_link of gac_links)gac_link.addEventListener("click", (e)=>{
            e.preventDefault();
            (0, $08fa37fff71de28c$export$209876d7b1ac8f3).y = window.scrollY;
            const url = e.target.getAttribute("url");
            this.axl.sendMessage((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).ChildToHost.NAVIGATE, url);
        });
    }
    // check images visibility
    visibilityCheck() {
        //
        requestAnimationFrame(this.visibilityCheck.bind(this));
        const { inside: inside, outside: outside, partial: partial } = (0, $08fa37fff71de28c$export$fa65b7c0510c5f90)();
        // do something with the insiders
        inside.forEach((image)=>{
            //inutile de tester, elle ne s'ajoute qu'une fois :)
            image.classList.add(image.dataset.transition);
        });
        // do something with the outsiders
        outside.forEach((image)=>{
            image.classList.remove(image.dataset.transition);
        });
        // check if we need to load new content ;
        if ((0, $08fa37fff71de28c$export$125277f405055675)()) this.emit("touch-bottom");
        //check if we need to add shadow to the header
        if (window.scrollY > 5) document.querySelector(".card").classList.add("shadow");
        else document.querySelector(".card").classList.remove("shadow");
    }
    onFirstContentLoaded() {
        if (this.mustClear === true && this.cleared === false) {
            this.clear();
            this.cleared = true;
        }
    }
    onLodComplete() {
        this.load();
    }
    onProgress() {
        document.querySelector(".progress").innerHTML = this.loadedImages + " / " + this.totalImages;
        this.loadedImages++;
    }
    onContentsComplete() {
        this.completed = true;
        this.resize();
        // this.resetTagListeners();
        this.resetGacLinkListeners();
        this.emit("all-contents-loaded");
        this.loading = false;
    }
    load() {
        if (this.pool.length == 0) {
            if (this.completed === false) return this.onContentsComplete();
        }
        const content = this.pool.shift();
        if (content == undefined) return;
        // clears the page when the first content is loaded
        content.once("content-loaded-before", this.handlers.onFirstContentLoaded);
        // set progress
        content.on("image-loaded", this.handlers.onProgress);
        // load next
        content.on("content-loaded", this.handlers.onLodComplete);
        for(let i = 0; i < Math.min(16, content.pool.length); i++)content.load();
    }
}



class $fae7057e7cec0a8c$export$2e2bcd8739ae039 extends (0, $28edd11f6c7e9f5f$exports.EventEmitter) {
    constructor(el){
        super();
        this.el = el;
        this.el.addEventListener("click", this.onClick.bind(this));
    }
    onClick(e) {
        if (!e.target.classList.contains("active")) {
            this.el.classList.toggle("checked");
            const children = this.el.children;
            Array.from(children).forEach((element)=>{
                element.classList.toggle("active");
            });
            // check if the input has been checked
            if (this.el.classList.contains("checked")) this.emit("toggle", true);
            else this.emit("toggle", false);
        }
    }
}




class $f7a8318b12f12568$export$2e2bcd8739ae039 {
    constructor(axl){
        this.axl = axl;
        this.trackingEvents = {
            UI_TOGGLE: {
                eventName: "toggle_ui",
                NI: false,
                value: 0
            },
            TAG_CLICKED: {
                eventName: "tag_click",
                NI: false,
                value: 0
            },
            HOME_CLICKED: {
                eventName: "home_click",
                NI: false,
                value: 0
            },
            SEARCH_TAG: {
                eventName: "search_tag_click",
                NI: false,
                value: 0
            },
            SEARCH: {
                eventName: "search",
                NI: false,
                value: 0
            },
            SHARE: {
                eventName: "share",
                NI: false,
                value: 0
            },
            BOOKMARK_REMOVE: {
                eventName: "bookmark_remove",
                NI: false,
                value: 0
            },
            BOOKMARK_ADD: {
                eventName: "bookmark_add",
                NI: false,
                value: 0
            }
        };
    }
    track(event, value = null) {
        if (this.axl) {
            const param = {
                action: this.trackingEvents[event].eventName,
                value: this.trackingEvents[event].value,
                nonInteraction: this.trackingEvents[event].NI
            };
            if (value) param["label"] = value;
            this.axl.sendMessage((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).ChildToHost.TRACK, param);
        }
    }
}


class $369883fbedbca0f7$var$Tooltips {
    constructor(){
        this.buttons = document.getElementsByClassName("tooltiped");
        this.tooltips = [];
        this.isTouchDevice = ()=>{
            return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        };
        let i = 0;
        for (const button of this.buttons){
            button.index = i;
            button.addEventListener("mouseleave", this.cursorLeave.bind(this));
            button.addEventListener("mouseenter", this.cursorEnter.bind(this));
            const div = document.createElement("div");
            div.classList.add("tooltip");
            if (button.classList.contains("tool-right")) div.classList.add("tooltip-right");
            if (button.classList.contains("special-right")) div.classList.add("specialTip-right");
            if (button.classList.contains("tool-top")) div.classList.add("tooltip-top");
            if (button.classList.contains("styled")) div.classList.add("styled");
            div.textContent = button.dataset.tooltip;
            this.tooltips.push({
                tooltip: div,
                target: button
            });
            document.body.appendChild(div);
            i++;
        }
    }
    cursorLeave(event) {
        this.hideToolTip(event.currentTarget.index);
    }
    cursorEnter(event) {
        if (!this.isTouchDevice()) this.showToolTip(event.currentTarget.index);
    }
    hideToolTip(index) {
        this.tooltips[index].tooltip.classList.remove("shown");
    }
    showToolTip(index) {
        const targetPosition = this.tooltips[index].target.getBoundingClientRect();
        const targetWidth = this.tooltips[index].target.offsetWidth;
        const targetHeight = this.tooltips[index].target.offsetHeight;
        const topOffset = this.tooltips[index].tooltip.classList.contains("tooltip-right") ? targetHeight / 2 : -10;
        const leftOffset = this.tooltips[index].tooltip.classList.contains("tooltip-right") ? targetWidth + 10 : targetWidth / 2;
        this.tooltips[index].tooltip.style.top = `${Math.round(targetPosition.top + topOffset)}px`;
        this.tooltips[index].tooltip.style.left = `${Math.round(targetPosition.left + leftOffset)}px`;
        this.tooltips[index].tooltip.classList.add("shown");
    }
    showToolTipForAWhile(index, time = 1000) {
        this.showToolTip(index);
        setTimeout(()=>{
            this.hideToolTip(index);
        }, time);
    }
}
var $369883fbedbca0f7$export$2e2bcd8739ae039 = $369883fbedbca0f7$var$Tooltips;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $6d2451f9c4d5f362$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $6d2451f9c4d5f362$var$USE_WORKER = false;
class $6d2451f9c4d5f362$export$2e2bcd8739ae039 {
    constructor(){
        // randomize the PRNG
        (0, $08fa37fff71de28c$export$20e67e28c05354ba).setSeed(Date.now());
        this.firstResume = true;
        this.prependApp();
    }
    iOS() {
        return [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform) || // iPad on iOS 13 detection
        navigator.userAgent.includes("Mac") && "ontouchend" in document;
    }
    async prependApp() {
        ////AXL
        this.axl = new (0, $bd226c24ee4b7195$export$2e2bcd8739ae039)();
        if (window._y010) {
            await this.preloadLayout();
            this.initApp();
        } else this.initAxL();
    }
    async initAxL() {
        //--------- PRELOAD OPTIONS HERE
        //const preloadData = await preloader();
        //------------
        const gotFirstResume = new Promise((resolve)=>{
            this.axl.registerMessageCallback((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).HostToChild.RESUME, (payload)=>{
                if (this.firstResume) {
                    this.firstResume = false;
                    resolve();
                } else if ((0, $08fa37fff71de28c$export$209876d7b1ac8f3).y) setTimeout(()=>{
                    window.scrollTo(0, (0, $08fa37fff71de28c$export$209876d7b1ac8f3).y);
                    (0, $08fa37fff71de28c$export$209876d7b1ac8f3).y = null;
                }, 10);
            });
        });
        const preloadThings = new Promise(async (resolve)=>{
            resolve();
        });
        const gameReady = this.axl.handshake().then(async (initialData)=>{
            try {
                this.axl.registerMessageCallback((0, $bd226c24ee4b7195$export$2e2bcd8739ae039).HostToChild.FREEZE, ()=>{});
                let objJsonStr = JSON.stringify(initialData);
                let objJsonB64 = $6d2451f9c4d5f362$require$Buffer.from(objJsonStr).toString("base64");
                this.tracker = new (0, $f7a8318b12f12568$export$2e2bcd8739ae039)(this.axl);
                await this.preloadLayout();
                this.INITIAL_BOOKMARK = initialData.bookmarks;
                if (this.INITIAL_BOOKMARK && this.INITIAL_BOOKMARK.length > 0) this.cleanupPage();
            } catch (error) {}
        });
        // Make sure game is initialized AND we got the first resume call
        Promise.all([
            gotFirstResume,
            preloadThings,
            gameReady
        ]).then(()=>{
            this.initApp();
        });
    }
    async initApp() {
        const queryString = window.location.search;
        this.urlParams = new URLSearchParams(queryString);
        // loader
        const loader = document.querySelector(".loader");
        const progress = document.querySelector(".progress");
        // toggle label
        this.label = document.querySelector(".card").getElementsByTagName("label")[0];
        //get h1
        this.letter = document.querySelector(".letter");
        const header = this.letter.querySelector("h1");
        header.addEventListener("click", async ()=>{
            // prevent header click in edit mode
            if (document.querySelector(".doubleButton").classList.contains("checked")) return;
            // display intro + random contents
            await this.layout.introduction(true);
            await this.layout.categories(3, 7, false);
            (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, this.iOS());
            if (this.axl) this.tracker.track("HOME_CLICKED");
        });
        const showPreload = ()=>{
            // unblur show contents when everything is loaded
            this.layout.once("all-contents-loaded", ()=>{
                loader.classList.add("hidden");
                document.body.classList.remove("loading");
            });
            // scroll up to prevent infinite scroll to trigger
            (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, this.iOS());
            // wait for the content to be loaded
            document.body.classList.add("loading");
            loader.classList.remove("hidden");
            progress.innerHTML = "";
        };
        // used when the search result is a tag or a when a tag was cliked
        const preloadTags = async (tag, clear = false)=>{
            this.forceSwitchClassicView();
            showPreload();
            await this.layout.tags(tag, clear);
        };
        //listen to the tags clicks
        this.layout.on("tag-clicked", async (tag)=>{
            // preloads a specific tag
            preloadTags(tag, true);
            if (this.axl) this.tracker.track("TAG_CLICKED", tag);
        });
        const preloadResultPage = async (tag, assets, type)=>{
            // scroll to top
            (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, this.iOS());
            if (type == "tag") {
                // clears the page and display the tag
                preloadTags(tag, true);
                if (this.axl) this.tracker.track("SEARCH_TAG", tag);
            } else if (type == "search") {
                // clears the page and display the search result
                if (assets.length == 0) // no results
                await this.layout.assets(assets.length + " search results for: " + tag, assets, true);
                else // blur the page while loading
                preloadSearchResults(tag, assets, true);
                if (this.axl) this.tracker.track("SEARCH", tag);
            }
        };
        // search result
        this.layout.on("search-result", preloadResultPage);
        // used when the search result is a a list of assets
        const preloadSearchResults = async (searchTerm, assetslist, clear = true)=>{
            showPreload();
            await this.layout.assets(assetslist.length + " search results for: " + searchTerm, assetslist, clear);
        };
        // infiniteScroll
        this.layout.on("touch-bottom", async ()=>{
            // we're viewing the custom edition and don't want anything to be added to the page
            if ((0, $af4794cc149d20b5$export$2e2bcd8739ae039).EDIT == true) return;
            // we're preloading something
            if (this.layout.loading == true) return;
            // a bit brutal maybe
            // this.layout.resetTagListeners();
            if (this.layout.notReady) {
                this.layout.notReady = false;
                await this.layout.categories(3, 7, false);
            }
        });
        const toggle = new (0, $fae7057e7cec0a8c$export$2e2bcd8739ae039)(document.querySelector(".doubleButton"));
        toggle.on("toggle", (value)=>{
            // scroll to top
            (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, this.iOS());
            if (value) {
                // displays the user selection or an intructions panel
                document.body.classList.add("modern");
                (0, $af4794cc149d20b5$export$2e2bcd8739ae039).EDIT = true;
                (0, $af4794cc149d20b5$export$2e2bcd8739ae039).INTERACTION = true;
                (0, $af4794cc149d20b5$export$2e2bcd8739ae039).HIDE_SHARING = false;
                this.layout.saveState();
                this.layout.clear();
                this.layout.bookmarks();
                this.previousTag = this.urlParams.get("tag");
            // window.history.pushState(
            //   { tag: "bookmarks" },
            //   "bookmarks",
            //   `?tag=bookmarks`
            // );
            } else {
                document.querySelector("#bookmarks").textContent = "My Bookmarks";
                // display the regular page (tags, random, categories, search results)
                document.body.classList.remove("modern");
                (0, $af4794cc149d20b5$export$2e2bcd8739ae039).EDIT = false;
                (0, $af4794cc149d20b5$export$2e2bcd8739ae039).INTERACTION = true;
                this.layout.restoreState();
            // window.history.pushState(
            //   { tag: this.previousTag },
            //   `${this.previousTag}`,
            //   `?tag=${this.previousTag}`
            // );
            }
            if (this.axl && this.tracker) this.tracker.track("UI_TOGGLE", value);
        });
        window.addEventListener("resize", this.resize.bind(this));
        // window.addEventListener("scroll", this.scroll.bind(this));
        // window.addEventListener("popstate", async (event) => {
        //   // Can access state data using event.state.data
        //   if (event.state) {
        //     switch (event.state.tag) {
        //       case "home":
        //         document.body.classList.remove("modern");
        //         toggle.el.checked = false;
        //         PRNG.setSeed(1);
        //         await this.layout.introduction(true);
        //         await this.layout.categories(3, 7, false);
        //         break;
        //       case "bookmarks":
        //         // toggle.onClick();
        //         document.body.classList.add("modern");
        //         toggle.el.checked = true;
        //         // Bookmark.EDIT = true;
        //         // this.layout.saveState();
        //         this.layout.bookmarks();
        //         this.previousTag = this.urlParams.get("tag");
        //         break;
        //       default:
        //         document.body.classList.remove("modern");
        //         toggle.el.checked = false;
        //         console.log("default config by tag", event.state.tag);
        //         preloadTags(event.state.tag, true);
        //     }
        //   }
        // });
        // document.addEventListener("click", (e) => {
        //   document.body.classList.toggle("modern");
        // });
        // const title = document.querySelector(".letter").getElementsByTagName("h1")[0];
        // title.addEventListener("click", () => {
        // });
        // console.log(title);
        // if  this.INITIAL_BOOKMARKS is not empty, we need to load the bookmarks layout
        if (this.INITIAL_BOOKMARK && this.INITIAL_BOOKMARK.length > 0) {
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).EDIT = true;
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).INTERACTION = false;
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection = [];
        }
    }
    cleanupPage() {
        if (this.INITIAL_BOOKMARK && this.INITIAL_BOOKMARK.length > 0) {
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).selection = this.INITIAL_BOOKMARK;
            this.layout.saveState();
            this.layout.bookmarks();
            document.body.classList.add("modern");
            document.querySelector("#bookmarks").textContent = "Special Edition";
            document.querySelector(".doubleButton").classList.add("checked");
            Array.from(document.querySelector(".doubleButton").children).forEach((item)=>{
                item.classList.toggle("active");
            });
        }
    }
    preloadLayout() {
        return new Promise(async (resolve)=>{
            await this.preloadData();
            this.toolTips = new (0, $369883fbedbca0f7$export$2e2bcd8739ae039)();
            this.layout = new (0, $abbe520c4a11007c$export$2e2bcd8739ae039)($6d2451f9c4d5f362$var$USE_WORKER, this.axl, this.tracker, this.toolTips);
            await this.layout.introduction();
            await this.layout.categories(3, 7, false);
            this.layout.once("all-contents-loaded", ()=>{
                (0, $08fa37fff71de28c$export$3f99968195accfaf)(0, this.iOS());
                resolve();
            });
        });
    }
    // preloads the JOSN contents
    async preloadData() {
        // fetch verso-recto dictionnary
        this.versoRecto = await (0, $08fa37fff71de28c$export$e7c8553478f3aac7)("./json/verso-recto.json");
        (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).versoRecto = this.versoRecto;
        //fetch the motherload
        const motherload = await (0, $08fa37fff71de28c$export$e7c8553478f3aac7)("./json/payload.json");
        (0, $ea7e40a66df43b78$export$1dc09377a991c7ad).parse(motherload);
    }
    resize() {
        this.layout.resize();
    }
    forceSwitchClassicView() {
        if (document.body.classList.contains("modern")) {
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).EDIT = false;
            (0, $af4794cc149d20b5$export$2e2bcd8739ae039).INTERACTION = true;
            document.body.classList.remove("modern");
            document.querySelector(".doubleButton").classList.remove("checked");
            Array.from(document.querySelector(".doubleButton").children).forEach((item)=>{
                item.classList.toggle("active");
            });
        }
    }
}


window.onload = ()=>{
    new (0, $6d2451f9c4d5f362$export$2e2bcd8739ae039)();
};


//# sourceMappingURL=index.9402613a.js.map
